<template>
  <section class="wrap">
    <div class="container-wrap">
      <div class="left">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="imgSrc in imageSources" :key="imgSrc">
            <img :src="imgSrc" />
          </swiper-slide>
          <div
            class="swiper-pagination swiper-pagination-bullets"
            slot="pagination"
          ></div>
        </swiper>
      </div>
      <div class="right">
        <div class="title-sub">물류 컨시어지 서비스</div>
        <div class="title" style="margin-top: 20px">
          기업 물류 관리가<br />고민이신가요?
        </div>
        <div class="description">
          퀵/택배 물품 수신부터 발송까지<br />디포스트에서 한번에
        </div>
        <div class="button-wrap">
          <button @click="openDpost()" class="ghost outline">
            디포스트 알아보기
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      imageSources: [
        require("@/assets/img/home/Dpost_1.png"),
        require("@/assets/img/home/Dpost_2.png"),
        require("@/assets/img/home/Dpost_3.png")
      ]
    };
  },
  components: { Swiper, SwiperSlide },
  methods: {
    openDpost() {
      window.open(`https://dpost.co.kr/`);
    }
  }
};
</script>
<style src="../home.common.css" scoped />
<style>
.swiper-pagination-bullet {
  background: var(--gray-500);
  opacity: 1;
  width: 7px;
  height: 7px;
}
.swiper-pagination-bullet-active {
  background: var(--white) !important;
}
</style>
<style scoped>
.description {
  font-size: 20px;
  line-height: 28px;
  font-weight: 300;
  color: var(--gray-500);
  margin-top: 20px;
}
.container-wrap {
  display: flex;
  flex-direction: column-reverse;
  gap: 40px;
}

.button-wrap {
  margin-top: 20px;
}

.swiper {
  width: 100%;
}
img {
  width: 100%;
  border-radius: 32px;
}

@media (min-width: 1024px) {
  .container-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }

  .swiper {
    width: 490px;
    height: 490px;
  }

  img {
    width: 490px;
    height: 490px;
  }

  .button-wrap {
    margin-top: 40px;
  }

  .description {
    font-size: 24px;
    line-height: 32px;
    margin-top: 40px;
  }

  .right {
    width: 405px;
  }
}
</style>
